module.exports = __webpack_public_path__ + "img/horizontal-dots-white.2b2c2867.svg";